import {MvsCrudService} from "./mvs-crud.service";

export class MvsCrudObjectAssignment {
    referenceId: number;
    serviceInterface: MvsCrudService;
}
